import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { LIBROSELECTRONICOS_CAJABANCOS } from 'constants/codigosTransacciones'

import CajaBancosPage from './cajaBancos'

export default function LibrosElectronicosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${LIBROSELECTRONICOS_CAJABANCOS}`} component={CajaBancosPage} />
      </Switch>
    </Suspense>
  )
}
